import { Moment } from 'moment'
import { adminHttpClient } from '../commons/adminHttpClient'

type RehireEmployeeProps = {
  companyUserId: string
  hireDate: Moment
  productClassId: string
  employmentStatus: number
  shouldRecreateCompanyUser: boolean
  renewalProductClassId: string
}

export const rehireEmployee = (request: RehireEmployeeProps) => {
  return adminHttpClient.put(`/Companies/RehireEmployee`, request)
}

export default rehireEmployee
